<div class="register-privacy">
  <div class="row">
    <div class="col-auto" [ngClass]="wideResolution ? 'mt-2' : 'mt-4'">
      <button class="d-flex align-items-center si-button_link-thick" type="button" (click)="onClickShowPrivacyInformation()">
        <span>{{'SI_PRIVACY_POLICY_SHOW' | translate}}</span>
        <i class="icosun-expand register-privacy_icon ml-2 mb-sm-1"></i>
      </button>
    </div>
    <div class="w-100"></div>
    <div class="col-auto" [ngClass]="wideResolution ? 'mt-2' : 'mt-4'">
      <button class="d-flex align-items-center si-button_link-thick" type="button" (click)="onClickShowTermsInformation()">
        <span>{{'SI_LEGAL_TERMS_SHOW' | translate}}</span>
        <i class="icosun-expand register-privacy_icon ml-2 mb-sm-1"></i>
      </button>
    </div>
    <div class="w-100"></div>
    <div *ngIf="!wideResolution" class="w-100 pasi-line-lightgrey"></div>
    <div class="col-12 mt-2">
      <si-check id="registerPrivacyPrivacyPolicy"
                name="registerPrivacyPrivacyPolicy"
                text="SI_PRIVACY_POLICY_ACCEPT"
                [(model)]="model.acceptPolicy"
                rule="generic.checkNotNull"
      ></si-check>
    </div>
    <div class="col-12 mt-2">
      <si-check id="registerPrivacyDataAccept"
                name="registerPrivacyDataAccept"
                text="SI_PRIVACY_POLICY_DATA_ACCEPT"
                [(model)]="model.acceptContactData"
      ></si-check>
    </div>
    <div *siEnvironment="[configVariableValues.CAPTCHA_ENABLED]"
         [hidden]="!captchaRendered || (!model.acceptPolicy && wideResolution)"
         class="col-12 mt-3">
      <si-captcha [type]="environment.captcha?.type"
                  [siteKey]="environment.captcha?.siteKey"
                  [scriptUrl]="environment.captcha?.scriptUrl"
                  [reset]="model.resetCaptcha"
                  [(captchaResponse)]="model.captchaResponse"
                  (captchaRenderedChange)="onChangeCaptchaRendered($event)"
      ></si-captcha>
    </div>
  </div>
  <ng-container *ngIf="showPrivacy">
    <si-info-dialog [(displayDialog)]="showPrivacy" [dialogTitle]="privacyTitle" [dialogText]="privacyModel?.content"></si-info-dialog>
  </ng-container>
  <ng-container *ngIf="showTerms">
    <si-info-dialog [(displayDialog)]="showTerms" [dialogTitle]="termsTitle" [dialogText]="termsModel?.content"></si-info-dialog>
  </ng-container>
</div>
